import { createApp } from 'vue';
import Rollbar from 'rollbar';
import GiftSignUpApp from '../giftSignUpApp.vue';

const app = createApp(GiftSignUpApp);
app.config.globalProperties.$rollbar = new Rollbar({
  accessToken: 'dd5d5ae121ed4ed5839a96cdd8c214dc',
  captureUncaught: true,
  captureUnhandledRejections: true,
});
app.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};

app.mount('#gift-signup-app');
